var React = require('react');

function HeaderWave (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0H1475V793C1475 793 1392.5 555.5 750 555.5C107.5 555.5 0 334.5 0 334.5V0Z","fill":"#15171E"}));
}

HeaderWave.defaultProps = {"width":"1475","height":"793","viewBox":"0 0 1475 793","fill":"none","preserveAspectRatio":"none"};

module.exports = HeaderWave;

HeaderWave.default = HeaderWave;
